interface RadioBoxNewIconProps {
  className?: string;
  checked?: boolean;
}

export const CircleRadioBoxIcon = ({ className, checked }: RadioBoxNewIconProps) =>
  checked ? (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#915FFF" />
      <circle cx="10" cy="10" r="4" fill="white" />
    </svg>
  ) : (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9" stroke="#D0D7DE" strokeWidth="1.2" />
    </svg>
  );
